/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {
    $Sprite,
    CanBeSignal,
    getProp,
} from '@gongxigames/framework/core/fragments/BuilderY';
import {$GameAlignContainer} from '@gongxigames/framework/slotV2/JSX/GameAlignContainer';
import {getOrientation} from '@gongxigames/framework/slotV2/modules/loadingScreenV2/utils/getOrientation';
import {LSViewConfig} from '@gongxigames/framework/slotV2/modules/loadingScreenV2/loadingScreenViewConfig';
import {Store} from '@gongxigames/framework/core';

export const renderBanner = (complete: CanBeSignal<boolean>) => {
    const isComplete = Store.computed(() => getProp(complete));

    return (
        <$GameAlignContainer align={[0.5, 0.5]}>
            <$Sprite
                texture={LSViewConfig.banner.completeBanner}
                visible={LSViewConfig.banner.shouldShowBanner && isComplete}
                position={getOrientation(LSViewConfig.banner.position)}
                scale={getOrientation(LSViewConfig.banner.scale)}
            />
        </$GameAlignContainer>
    );
};